module.exports = __webpack_public_path__ + "static/media/arymite.4c9e4af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/aranha_roja_fresa/curativa/arymite.png
// module id = 1535
// module chunks = 3